<div aria-labelledby="contact-tab" class="tab-pane fade" id="day4" role="tabpanel">
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p> {{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <FlashMessage></FlashMessage>
            <form>
                <div class="form-modified">
                    <div class="empty-data green">
                        <p>
                            Hotel in city.
                        </p>
                    </div>
                    <div class="form-group row">
                        <label class class="col-sm-2 col-form-label" for="staticEmail">
                            Hotel City<span
                                    class="required">*</span></label></label>
                        <div class="col-sm-8">
                            <div v-if="!ui.status.canEdit">
                                <label class="readonly" for="staticEmail">{{item.locationData.city?item.locationData.city.name:'-'}}</label>
                            </div>
                            <div v-if="ui.status.canEdit">
                                <div class="multiselect-input" v-if="item.cityList">
                                    <multiselect :options='item.cityList' :track-by="'name'" label="name" placeholder="Choose City.." v-model="item.locationData.city">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="includes-action text-right">
                                <button @click.prevent="onAddCityClick" class="btn blue" data-toggle="modal" type="button">
                                        <i class="fas fa-plus"></i>
                                    </button>
                            </div>
                        </div>
                    </div>


                    <div class="content-block">
                        <div class="row">
                            <div class="col-md-10 offset-md-2">
                                <button @click.prevent="onEditLocationClick" class="btn default-btn" type="submit" v-if="!ui.status.canEdit">
                                    Edit
                                </button>
                                <button @click.prevent="createLocation" class="btn default-btn save-btn" type="submit" v-if="ui.status.canEdit">{{buttonName}}
                                    <spinner :loading="ui.status.postLoading.addLocation" v-if="ui.status.postLoading.addLocation"></spinner>
                                </button>
                                <button @click.prevent="cancelLocation" class="btn default-btn cancel" type="submit" v-if="ui.status.canEdit" :disabled="ui.status.postLoading.addLocation">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>


    <!-- Modal -->
    <div class="modal-wrap">
        <div aria-hidden="true" aria-labelledby="exampleModalCenterTitle" class="modal fade" id="addCity" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Add City</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click.prevent="onCancelCityClick">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="error-list" v-if="ui.error.error_message.saveCity">
                            <ul class="error-msg">
                                <li :key="x" v-for="(error,x) in ui.error.error_message.saveCity">
                                    <div :key="i" v-for="(err,i) in error">
                                        <p> {{err}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="form-modified">
                            <div class="form-group">
                                <input class="form-control" placeholder="eg.Pokhara" type="text" v-model="item.addCity.name" :class="{ 'error-input' : ui.error.errors['name'] }">
                                <validation-error :errors="ui.error.errors" :field="'name'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button :disabled="ui.status.postLoading.saveCity" @click.prevent="saveCity" class="btn default-btn" type="button">Save
                        </button>
                        <button :disabled="ui.status.postLoading.saveCity" @click.prevent="onCancelCityClick" aria-label="Close" class="btn default-btn cancel" type="button">Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>